import React, { useEffect, Fragment } from 'react';
import { Row, Col, Form, Button, message } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { id, addTaxCondition, updateTaxCondition, meta, data, mode, reloadApi, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'code',
      label: t("General.code"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'desc',
      label: t("General.desc"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    // {
    //   type: 'switch',
    //   name: 'is_inclusive',
    //   label: 'Tax Inclusive?',
    //   req: false,
    //   twocol: true,
    //   colWidth: '1 0 100%',
    //   alignEnd: true,
    //   static: !allowedEdit
    // },
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      setValue('code', data.code);
      setValue('desc', data.desc);
      // setValue('is_inclusive', data.is_inclusive == "1");
    }
  }, [data]);

  const onFinish = async (val) => {
    if (mode === 'add') {
      return onFinishAdd(val);
    }
    props.setLoading(true);
    const payload = {
      ...val,
      // is_inclusive: val?.is_inclusive ? 1 : 0,
      tax_condition_id: id
    }

    await updateTaxCondition(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("System.update_tax_con_success"));
        reloadApi();
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  const onFinishAdd = async (val) => {
    props.setLoading(true);

    const payload = {
      ...val,
      // is_inclusive: val?.is_inclusive ? 1 : 0,
    }
    await addTaxCondition(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("System.tax_con_create_success"));
        setTimeout(() => reloadApi(res.data.data), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}